import { render } from "./VendorProductItem.vue?vue&type=template&id=76d00084"
import script from "./VendorProductItem.vue?vue&type=script&lang=js"
export * from "./VendorProductItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__